// import { AppBar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Modal, Toolbar, Typography, useTheme } from '@mui/material'
// import React, { memo } from 'react'
// import CloseIcon from '@mui/icons-material/Close';

// function AppModal({ open, handleClose, children }) {
//     const { palette } = useTheme()
//     return (
//         <Dialog fullScreen open={open} onClose={handleClose}>
//             <DialogContent sx={{ padding: 0, margin: 0 }}>
//                 <IconButton size='small' sx={{ display: "flex", marginLeft: "auto", alignSelf: "center" }} onClick={handleClose}>
//                     <CloseIcon />
//                 </IconButton>
//                 {children}
//             </DialogContent>
//         </Dialog>
//     )
// }

// export default memo(AppModal)


import {
    Dialog,
    DialogContent,
    IconButton,
    useTheme
  } from '@mui/material';
  import CloseIcon from '@mui/icons-material/Close';
  import React, { memo } from 'react';
  
  function AppModal({ open, handleClose, children }) {
    const { palette } = useTheme();
  
    return (
      <Dialog fullScreen open={open} onClose={handleClose}>
        <DialogContent
          sx={{
            padding: 0,
            margin: 0,
            backgroundColor: "#000", // black background
            color: "#fff",           // white text
          }}
        >
          <IconButton
            size="small"
            onClick={handleClose}
            sx={{
              display: "flex",
              marginLeft: "auto",
              alignSelf: "center",
              color: "#fff", // white icon color
            }}
          >
            <CloseIcon />
          </IconButton>
  
          {/* Ensure children text is white */}
          <div style={{ color: "#fff" }}>
            {children}
          </div>
        </DialogContent>
      </Dialog>
    );
  }
  
  export default memo(AppModal);
  